export default "__VITE_ASSET__Dl4Laqkq__"